import { Price } from '@components'
import type { TypographyElementType } from '../../types/widget-types'
import { useEventBusOn, productChannel } from '@haus-storefront-react/core'
import styles from './Price.module.scss'

type PriceAttributes = {
  configStyles?: {
    priceTypography?: {
      variant?: string
      tag?: TypographyElementType
      color?: string
    }
    listPriceTypography?: {
      variant?: string
      tag?: TypographyElementType
      color?: string
    }
  }
}

const PriceWidget = ({ configStyles }: PriceAttributes) => {
  const [selectedProductVariant] = useEventBusOn(
    productChannel,
    'product:variant:selected',
    undefined,
    undefined,
    false, // Do not replay past events when subscribing; only respond to new selections
  )

  if (
    !selectedProductVariant?.price ||
    !selectedProductVariant?.priceWithTax ||
    !selectedProductVariant?.currencyCode
  ) {
    return null
  }

  return (
    <Price
      key={selectedProductVariant.id}
      price={selectedProductVariant.price}
      priceWithTax={selectedProductVariant.priceWithTax}
      listPrice={selectedProductVariant.listPrice}
      listPriceWithTax={selectedProductVariant.listPriceWithTax}
      currencyCode={selectedProductVariant.currencyCode}
      productVariant={selectedProductVariant}
      themeConfig={{
        priceTypography: {
          variant: configStyles?.priceTypography?.variant ?? 'body',
          tag: configStyles?.priceTypography?.tag ?? 'span',
          color: configStyles?.priceTypography?.color ?? 'body',
        },
        listPriceTypography: {
          variant: configStyles?.listPriceTypography?.variant ?? 'body',
          tag: configStyles?.listPriceTypography?.tag ?? 'span',
          color: configStyles?.listPriceTypography?.color ?? 'body',
        },
      }}
      className={styles.pricewrapper}
    />
  )
}

export default PriceWidget
